<template>
  <PerkContainer
    :icon="isBcom ? 'financing-dark-medium' : 'financing'"
    @value-info-click="openOverlay"
  >
    <Ccfp
      :price="selectedPrice"
      :is-modal-open="isModalOpen"
      :is-product-perks-enabled="true"
      @close-ccfp-modal="onModalClose"
    />
  </PerkContainer>
</template>
<script setup>
/* istanbul ignore file */
import { ref } from 'vue';
import Ccfp from '@common-vue/media-card-large/src/modules/credit-finance/components/Ccfp';
import PerkContainer from '@modules/productPerks/components/PerkContainer';
import { useProductPrice } from '@modules/price';
import { useBrand } from '@composables/useBrand';
import once from '@utils/once';
import { ccfpDetailsClicked } from '../../../features/analytics/productPerks';

const selectedPrice = useProductPrice();
const { isBcom } = useBrand();

const fireAnalytics = once(ccfpDetailsClicked);
const isModalOpen = ref(false);
const openOverlay = () => {
  fireAnalytics();
  isModalOpen.value = true;
};
const onModalClose = () => {
  isModalOpen.value = false;
};
</script>

<style lang="scss" scoped>
:deep(.ccfp-offer-wrapper) {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
}
</style>
